import { Box, Chip, Divider, Grid, Typography, useTheme } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faRocket,
  faTableColumns,
  faWandMagicSparkles
} from "@fortawesome/free-solid-svg-icons";

import { hexToRgba } from "@aclymatepackages/converters";

const FeatureRow = ({ icon, iconColor, title, description }) => (
  <Grid container alignItems="flex-start" spacing={2} wrap="nowrap">
    <Grid item>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          width: 40,
          height: 40,
          borderRadius: 2,
          backgroundColor: hexToRgba(iconColor, 0.15),
          color: iconColor
        }}
      >
        <FontAwesomeIcon icon={icon} style={{ color: iconColor }} />
      </Box>
    </Grid>
    <Grid item xs>
      <Typography variant="subtitle1">{title}</Typography>
      <Typography variant="body2" color="textSecondary">
        {description}
      </Typography>
    </Grid>
  </Grid>
);

const ExplorerSignupSidePanel = () => {
  const { palette } = useTheme();

  const featureRows = [
    {
      icon: faTableColumns,
      iconColor: palette.primary.main,
      title: "Redesigned dashboard",
      description: "Cleaner, faster, easier to use."
    },
    {
      icon: faChartLine,
      iconColor: palette.info?.main || palette.primary.dark,
      title: "Deeper footprint insights",
      description: "Clearer Scope 1, 2 & 3 visibility."
    },
    {
      icon: faWandMagicSparkles,
      iconColor: palette.secondary.main,
      title: "Scout AI guidance",
      description: "Smarter recommendations for your next steps."
    }
  ];

  return (
    <Box
      p={4}
      sx={{
        borderRadius: 3,
        background: `linear-gradient(180deg, ${hexToRgba(
          palette.primary.light,
          0.12
        )} 0%, ${hexToRgba(palette.secondary.light, 0.08)} 100%)`,
        border: `1px solid ${hexToRgba(palette.primary.light, 0.4)}`
      }}
    >
      <Grid container direction="column" spacing={3}>
        <Grid item>
          <Chip
            label="COMING SOON"
            size="small"
            sx={{
              backgroundColor: hexToRgba(palette.primary.main, 0.15),
              color: palette.primary.dark,
              fontWeight: 600,
              letterSpacing: 0.5
            }}
          />
        </Grid>
        <Grid item>
          <Typography variant="h3">
            Explorer v2{" "}
            <Typography
              component="span"
              variant="h3"
              color="primary"
              display="inline"
            >
              is almost here.
            </Typography>
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" color="textSecondary">
            A new Aclymate Explorer experience with smarter insights, improved
            supplier tools, and AI guidance from Scout.
          </Typography>
        </Grid>
        <Grid item container direction="column" spacing={2}>
          {featureRows.map((feature) => (
            <Grid item key={feature.title}>
              <FeatureRow {...feature} />
            </Grid>
          ))}
        </Grid>
        <Grid item>
          <Divider />
        </Grid>
        <Grid item>
          <Grid container alignItems="flex-start" spacing={2} wrap="nowrap">
            <Grid item>
              <FontAwesomeIcon
                icon={faRocket}
                style={{ color: palette.primary.main, fontSize: 24 }}
              />
            </Grid>
            <Grid item xs>
              <Typography variant="subtitle1">
                Start now. Be ready for what's next.
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Create your free account today and start with Explorer v1.
                You'll be ready for the upgraded experience when it launches.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
export default ExplorerSignupSidePanel;
